/**
 * Prepares a list of ingredients by flattening one level of child ingredients into the main list and removing duplicates based on ingredient names.
 * If an ingredient has children (`IngredientChildren`), the parent ingredient is removed, and its children are added to the main list.
 * This process ensures that all child ingredients are directly included in the list, and each ingredient name appears only once.
 *
 * @param {ItemIngredient[]} itemIngredients - An array of `ItemIngredient` objects to be processed. Each `ItemIngredient` may contain an array of child ingredients (`IngredientChildren`).
 * @returns {ItemIngredient[]} A processed array of `ItemIngredient` objects with child ingredients flattened into the main list and duplicates removed. Returns an empty array if the input is null, undefined, or empty.
 */
export const prepareIngredientsList = (itemIngredients) => {
    if (!itemIngredients || !itemIngredients.length) {
        return [];
    }
    // Create a copy of the itemIngredients array to avoid modifying the original array during iteration
    let allItemIngredients = [...itemIngredients];
    // Create a new array to hold the final list of ingredients, including children
    let finalIngredientsList = [];
    allItemIngredients.forEach((ingredient) => {
        if (ingredient.IngredientChildren && ingredient.IngredientChildren.length > 0) {
            // If the ingredient has children, add those children to the final list
            finalIngredientsList.push(...ingredient.IngredientChildren);
        }
        else {
            // Add the ingredient itself to the final list
            finalIngredientsList.push(ingredient);
        }
    });
    // Remove duplicates from the final list
    return [...new Set(finalIngredientsList)];
};
